import { render, staticRenderFns } from "./payCode.vue?vue&type=template&id=55f25129&scoped=true"
import script from "./payCode.vue?vue&type=script&lang=js"
export * from "./payCode.vue?vue&type=script&lang=js"
import style0 from "./payCode.vue?vue&type=style&index=0&id=55f25129&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f25129",
  null
  
)

export default component.exports